import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
export default class ErrorBoundary extends Component {
    state = { message: null };
    static getDerivedStateFromError(error) {
        return { message: error instanceof Error ? error.message : String(error) };
    }
    componentDidCatch(error, info) {
        console.error('GESTIORA frontend error', error, info.componentStack);
    }
    render() {
        if (this.state.message) {
            return (_jsx("main", { className: "content", children: _jsxs("section", { className: "prose", children: [_jsx("h1", { children: "GESTIORA" }), _jsx("p", { className: "error", children: "No se pudo cargar la interfaz." }), _jsx("pre", { className: "result", children: this.state.message })] }) }));
        }
        return this.props.children;
    }
}
